// extracted by mini-css-extract-plugin
module.exports = {"fallback":"fallback--1HHlh","fallback__text":"fallback__text--3ggl5"};